import { useState } from "react";
import { Search } from "lucide-react";
import { Link } from "react-router-dom";

export default function SearchPage() {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState<string[]>([]);

    const handleSearch = () => {
        // 🔍 For now, simulate results — you can later integrate Supabase / API search
        if (!query.trim()) {
            setResults([]);
            return;
        }

        setResults([
            `Result for "${query}" – Example 1`,
            `Result for "${query}" – Example 2`,
            `Result for "${query}" – Example 3`,
        ]);
    };

    return (
        <main className="bg-gradient-to-b from-slate-900 to-black text-gray-100 min-h-screen py-16 px-6">
            <div className="max-w-3xl mx-auto">
                <h1 className="text-4xl font-bold text-white text-center mb-8">
                    Search SecureID Technologies
                </h1>

                <div className="flex items-center gap-3 bg-white rounded-xl shadow-lg p-3">
                    <Search className="text-indigo-600 w-6 h-6" />
                    <input
                        type="text"
                        placeholder="Search products, pages, or documentation..."
                        className="flex-1 text-gray-900 placeholder-gray-500 outline-none"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                    />
                    <button
                        onClick={handleSearch}
                        className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700"
                    >
                        Go
                    </button>
                </div>

                <div className="mt-10 space-y-4">
                    {results.length === 0 ? (
                        <p className="text-center text-gray-400">
                            Type a keyword and press <strong>Enter</strong> to search.
                        </p>
                    ) : (
                        results.map((r, i) => (
                            <div
                                key={i}
                                className="bg-white/5 border border-white/10 rounded-xl p-4 hover:bg-white/10 transition"
                            >
                                <Link to="/" className="text-indigo-400 hover:underline">
                                    {r}
                                </Link>
                            </div>
                        ))
                    )}
                </div>

                <p className="mt-12 text-center text-sm text-gray-500">
                    <Link to="/" className="text-indigo-400 hover:underline">
                        ← Back to Home
                    </Link>
                </p>
            </div>
        </main>
    );
}
